import React from "react";
import { APP_STORE } from "./Sections";

const CARDS = [
  ["card-quantum-leap.jpg", "Quantum Leap Walk meditation"],
  ["card-lucky-energy.jpg", "Tap into Lucky Energy meditation"],
  ["card-confidence.jpg", "Confidence Declarations meditation"],
  ["card-beauty.jpg", "Beauty Declarations meditation"],
];

export const Closing = () => (
  <section className="closing reveal in-view" data-testid="closing-section" style={{ backgroundImage: "url(/mm/clouds.webp)" }}>
    <div className="float-card-grid">
      {CARDS.map(([src, alt], i) => (
        <img key={src} className={`float-card fc-${i + 1}`} src={`/mm/${src}`} alt={alt} />
      ))}
    </div>
    <div className="closing-inner" id="keep-going">
      <div className="label">Keep it going</div>
      <h2 className="closing-title">Rehearse your future self with guided audio</h2>
      <p>This practice grows more potent every time you return, because of the <em>intention</em> you bring to it. Come back whenever you want to consciously create your life.</p>
      <p>Manifesting isn't a one-day event, it's a daily practice. The Radiate app makes it effortless to show up for your vision every day, whether you're walking or seated, while regulating your nervous system along the way. Your future self starts with what you do today.</p>
      <a className="mono-btn app-btn" href={APP_STORE} target="_blank" rel="noopener noreferrer" data-testid="app-store-btn">Try the app, one week free</a>
    </div>
  </section>
);

export const Mark = () => (
  <div className="mark">
    <a className="mark-link" href="https://www.modernmind.earth/" target="_blank" rel="noopener noreferrer" data-testid="footer-mark-link">
      <div className="mark-title">Modern Mind</div>
      <div className="mark-text">the light is in you</div>
    </a>
  </div>
);
